export default __webpack_public_path__ + "static/blog-image-3-f0b828d8a1302915538097e9068acb38.png";